// extracted by mini-css-extract-plugin
export default {"a11yFocus":"JzTHR","a11YFocus":"JzTHR","submitButton":"ldqMv","logo":"OzNrF","centered":"rXFLu","secondaryLogo":"GH2I7"};